import { useContext, useEffect } from "react";

import { AuthContext } from '../../store/AuthContext';

const Login = () => {


    const { login,loginUser } = useContext(AuthContext);

    useEffect(() =>{
      loginUser();
    //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <>
          { login ? <span className="visually-hidden">Logando...</span> : <span className="visually-hidden">logar...</span> }
        </>

      );
    }

export default Login